/**
 * Live Feed Tick Age and Latency Status Formatter.
 *
 * Computes tick staleness and badge classes (fresh, warm, stale, idle)
 * for the live WebSocket feed monitor.
 */

export interface TickAgeDisplay {
  text: string;
  className: string;
}

/**
 * Formats the age of the last live price tick.
 */
export function formatTickAge(
  lastTickTs: number | null | undefined,
  now: number = Date.now(),
): TickAgeDisplay {
  const age = lastTickTs ? now - lastTickTs : Infinity;
  if (!lastTickTs || age > 10000) {
    return { text: "idle", className: "tick-age stale" };
  }

  const text = age < 1000 ? `${age}ms` : `${(age / 1000).toFixed(1)}s`;
  const badgeState = age < 500 ? "fresh" : age < 2000 ? "warm" : "stale";

  return {
    text,
    className: `tick-age ${badgeState}`,
  };
}
